import { render, staticRenderFns } from "./kCategoryDetail.vue?vue&type=template&id=9d607caa&scoped=true"
import script from "./kCategoryDetail.vue?vue&type=script&lang=js"
export * from "./kCategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./kCategoryDetail.vue?vue&type=style&index=0&id=9d607caa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d607caa",
  null
  
)

export default component.exports